import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  tile: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    padding: 4,
    boxSizing: 'border-box',
    borderRadius: 2,
    color: 'var(--ds-color-white)',
  },
  largeTile: {
    width: 32,
    height: 32,
  },
  // The categorical palette preserves the workflow editor's stage identities.
  'ai-interview': { backgroundColor: '#9664FF' },
  archived: { backgroundColor: 'var(--ds-color-neutral-400)' },
  assessment: { backgroundColor: 'var(--ds-color-neutral-900, #0f172a)' },
  'background-check': { backgroundColor: '#AB3567' },
  custom: { backgroundColor: '#F6D057' },
  'data-collection': { backgroundColor: '#9790E7' },
  form: { backgroundColor: '#64C8E6' },
  hired: { backgroundColor: '#00B473' },
  integration: { backgroundColor: '#9664FF' },
  'job-selector': { backgroundColor: '#FFA963' },
  'job-switcher': { backgroundColor: '#FC6B3D' },
  learning: { backgroundColor: '#C896FF' },
  multi: { backgroundColor: '#FF8CCC' },
  partner: { backgroundColor: '#9664FF' },
  rejected: { backgroundColor: '#FF4141' },
  review: { backgroundColor: '#C245A2' },
  rule: {
    backgroundColor: 'var(--ds-color-neutral-200)',
    color: 'var(--ds-color-neutral-400)',
  },
  scheduler: { backgroundColor: '#6FD8AC' },
  signing: { backgroundColor: '#11B1B7' },
  'tech-check': { backgroundColor: '#6889E2' },
  'video-recording': { backgroundColor: '#008773' },
});
